module.exports = __webpack_public_path__ + "static/media/vid1.78f1889f.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Era/vid1.mp4
// module id = 1166
// module chunks = 0